import { connect } from "react-redux";
import UnitText from "./UnitText";

export default connect(state => ({
	units: state.units
}))(UnitText);
